import apiManager from '@/api';

const module = {
  namespaced: true,
  state: () => ({
    solutions: [],
  }),
  mutations: {
    setSolutions(state, solutions) {
      state.solutions = solutions;
    },
  },
  actions: {
    async loadSolutions({ commit }) {
      const { data } = await apiManager.events.getEventTypeSolutions();
      commit('setSolutions', data);
    },
  },
};

export default module;
